$(document).on('click', '[data-customizer-toggle]', function () {
    let $this = $(this);
    wp.customize.preview.send('preview-move', {
        type: $this.data('customizer-toggle'),
        id  : $this.data('id')
    });
});